import { render, staticRenderFns } from "./StudBookSearchInput.vue?vue&type=template&id=25f50f14&scoped=true"
import script from "./StudBookSearchInput.vue?vue&type=script&lang=ts"
export * from "./StudBookSearchInput.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25f50f14",
  null
  
)

export default component.exports